import { useMemo } from 'react';
import styled from 'styled-components';

import { ChevronIcon } from '@assets/icons';
import { UnstyledButton } from '@components/UnstyledButton/UnstyledButton';
import { StyledPostInfo } from '@views/styles';

import { PostDatePosted } from '../components/PostDatePosted';
import { PostHeader } from '../components/PostHeader';
import { PostMainInfo } from '../components/PostMainInfo';
import { PostSecondaryInfo } from '../components/PostSecondaryInfo';

import { StyledContainer, StyleMainContainer } from './styles';

type JobsBoardPostProps = {
  post: JobsBoardApplication;
  onOpenDrawer: (applicationId: number) => void;
  selectedJobPostApplicationId: number | undefined;
  isDrawerOpen: boolean;
};

export const JobsBoardPost = ({
  post,
  onOpenDrawer,
  selectedJobPostApplicationId,
  isDrawerOpen,
}: JobsBoardPostProps) => {
  const isJobPostSelected = useMemo(
    () =>
      !!selectedJobPostApplicationId &&
      selectedJobPostApplicationId === post?.id &&
      isDrawerOpen,
    [selectedJobPostApplicationId, post?.id, isDrawerOpen]
  );

  return (
    <StyledContainer isJobPostSelected={isJobPostSelected}>
      <StyleMainContainer>
        <PostHeader
          postRoleName={post?.role?.name}
          postProjectName={post?.project_name}
          postProjectLocation={post?.project_location}
          postStatus={post?.application_status}
          postCloseDate={post?.jobs_board_close_submissions_date_time}
        />

        <StyledPostInfo>
          <PostMainInfo post={post} hasSplitView />
          <div className='item-info-section-divider' />
          <PostSecondaryInfo post={post} hasSplitView />
        </StyledPostInfo>
      </StyleMainContainer>
      <StyledFooter>
        <PostDatePosted
          jobs_board_date_time_posted={post?.jobs_board_date_time_posted}
          projectCountry={post?.project_location?.country}
        />
        <UnstyledButton
          className='view-details'
          onClick={() => onOpenDrawer(post?.id)}
        >
          <div className='view-details-text'>View Details</div>
          <div className='icon-container'>
            <ChevronIcon direction='right' />
          </div>
        </UnstyledButton>
      </StyledFooter>
    </StyledContainer>
  );
};

const StyledFooter = styled.div`
  padding: 4px 7px 3px 15px;
  display: flex;
  gap: 2px;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  .view-details {
    padding: 8px 12px 8px 16px;
    font-size: 14px;
    line-height: 20px;
    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    .icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
    }

    .view-details-text {
      font-weight: 600;
    }
  }
  @media (max-width: 768px) {
    .view-details {
      padding: 12px 8px;
      line-height: 24px;
      font-size: 16px;
      .icon-container {
        width: 20px;
        height: 20px;
      }
    }

    .date-posted {
      font-size: 14px;
    }
  }
`;
